/**
 * Sources / Retirement / Components / Custom  > Hero
 *
 * @copyright 2025 i-fabrik GmbH
 * @author Tobias Garz
 */

import {extend} from '../../../../shared/utils';
import {
	isElement,
	isString
} from '../../../../shared/utils/is';

import SelectorEngine from '../../../../shared/dom/selector-engine';
import Data           from '../../../../shared/dom/data';
import Manipulator    from '../../../../shared/dom/manipulator';

import Slider from '../../../../shared/components/slider';

// -------
// Private
// -------

const NAME     = 'hero';
const DATA_KEY = `ifab.${NAME}`;

const DEFAULTS = {
	slidesPerView: 'auto',
	spaceBetween : 0
};

const renderSlider = (element) => {
	if(!element || !isElement(element)) {
		return;
	}

	// Wurde Element schon initialisiert?
	if (Data.get(element, `${DATA_KEY}.initialized`)) {
		return element;
	}

	Slider.init(element, DEFAULTS);

	// Initialisierungsstatus setzen.
	Data.set(element, `${DATA_KEY}.initialized`, true);

	return element;
};

// ------
// Public
// ------

const init = () => {
	let collection = SelectorEngine.find(`[data-c="${NAME}-slider"]`);

	for(const element of collection) {
		renderSlider(element);
	}
};

// Export
export default {
	init: init
};